import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './footer.module.css';
import { Row, Col } from 'react-bootstrap';
import { withTranslation } from "react-i18next";

class Footer extends Component {
  render() {
    const { t } = this.props;

    return (
      <>
        <div className={styles.footer_top}>
          <div className={styles.inner}>
            <Row>
              <Col sm={12} lg={6} md={6} xs={12}>
                <div>
                  <Link className={styles.text_4xl} to={'/'}>
                    <span
                      style={{ visibility: 'visible' }}
                      className={styles.font_serif}
                    >
                      {t("web_name")}
                    </span>
                  </Link>
                </div>
        
              </Col>
              <Col sm={12} lg={6} md={6} xs={12}>
                <Row>
                  <Col sm={6} lg={6} md={6} xs={6}>
                    <div>
                      <ul className={styles.list_inline}>
                        <li>
                        <Link
                            to="/aboutus"
                            target="_self"
                            className={styles.first}
                          >
                            About Us
                          </Link>
                        </li>
                        <li>
                        <Link
                            to="/cookiePolicy"
                            target="_self"
                            className={styles.first}
                          >
                            Cookie Policy
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/yourprivacy"
                            target="_self"
                            className={styles.first}
                          >
                            Your Privacy
                          </Link>
                        </li>
                        
                      </ul>
                    </div>
                  </Col>
                  <Col sm={6} lg={6} md={6} xs={6}>
                    <div>
                      <ul className={styles.list_inline}>
                        <li>
                          <Link
                            to="/cn/staticpages/connectus"
                            target="_self"
                            className={styles.first}
                          >
                            Contact Us
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/userterms"
                            target="_self"
                            className={styles.first}
                          >
                            Terms of Use
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/dcma"
                            target="_self"
                            className={styles.first}
                          >
                            DCMA
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/openStore"
                            target="_self"
                            className={styles.first}
                          >
                            Open a store
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
                
              </Col>
            </Row>
            <Row className={styles.copyRight}>
                  <p className={styles.destext}>
                  © Copyright 2024 RecentLover Group
                  </p>
                </Row>
          </div>
        </div>
      </>
    );
  }
}
export default withTranslation()(Footer);